export default __webpack_public_path__ + "static/media/layout-type-vertical.57dd4667.svg";